import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=c66d1e22&scoped=true&"
import script from "./EmptyData.vue?vue&type=script&lang=ts&"
export * from "./EmptyData.vue?vue&type=script&lang=ts&"
import style0 from "./EmptyData.vue?vue&type=style&index=0&id=c66d1e22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66d1e22",
  null
  
)

export default component.exports